__webpack_require__.p = "https://briz.tv/";